import PropTypes from 'prop-types';
import { Navigate } from 'react-router-dom';
// contexts
import useAuth from '../../contexts/AuthContext';

// ----------------------------------------------------------------------

GuestGuard.propTypes = {
  children: PropTypes.node
};

export default function GuestGuard({ children }) {
  const { isAuthenticated } = useAuth();

  if ( isAuthenticated ) {
    return <Navigate to="/" />;
  }

  return <>{children}</>;
}